import Box from 'apollo-react/components/Box';
import InfoIcon from 'apollo-react-icons/Info';
import React from 'react';

const getInfoBlockColor = (type) => {
  switch (type) {
    case 'warning':
      return 'rgba(255, 147, 0, 0.2)';
    default:
      return 'rgba(26, 162, 81, 0.12)';
  }
};

const InfoBlock = ({ type, children }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: getInfoBlockColor(type),
        padding: '15px 15px 15px 45px',
        borderRadius: 2,
        marginBottom: 2,
      }}
    >
      <InfoIcon
        fontSize="small"
        sx={{
          position: 'absolute',
          top: 15,
          left: 15,
          color: 'gray',
        }}
      />
      {children}
    </Box>
  );
};

export default InfoBlock;
